(function () {
  function initMenkrafters(root) {
    if (!root || root.dataset.menkraftersReady === 'true') return;

    root.dataset.menkraftersReady = 'true';
    root.classList.add('mk-enhanced');

    const items = root.querySelectorAll('.mk-reveal');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window) || reduceMotion) {
      items.forEach((item) => item.classList.add('mk-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('mk-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.1 }
    );

    items.forEach((item) => observer.observe(item));
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-menkrafters-services]').forEach(initMenkrafters);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
